import { zodResolver } from '@hookform/resolvers/zod';
import VyDialog from 'apps/app/src/components/new-design/feedback/VyDialog';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';
import { StripeCustomersForm } from './StripeCustomersForm';

export const StripeCustomerSchema = z.object({
  stripeCustomerId: z.string().nonempty(),
});
export type StripeCustomersDialog = z.infer<typeof StripeCustomerSchema>;

type StripeCustomersDialogFormProps = {
  open: boolean;
  onChoose: (customerId: string) => void;
  onClose?: () => void;
};

export const StripeCustomerDialogForm: React.FC<StripeCustomersDialogFormProps> = ({
  open,
  onClose,
  onChoose,
}) => {
  const form = useForm<StripeCustomersDialog>({
    resolver: zodResolver(StripeCustomerSchema),
  });
  
  const handleSubmit = () => {
    onChoose(form.getValues().stripeCustomerId);
    handleClose();
  };

  const handleClose = () => {
    onClose?.();
    form.reset();
  };

  return (
    <>
      <VyDialog
        open={open}
        onClose={handleClose}
        label="Link Your Stripe Customer"
        labelDescription="Link customer entities to share payments data and invoices."
        ctaText="Save"
        cancelButtonText="Cancel"
        onSubmit={handleSubmit}
      >
        <FormProvider {...form}>
          <form>
            <StripeCustomersForm/>
          </form>
        </FormProvider>
      </VyDialog>
    </>
  );
};
